var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkaazLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 40,
    viewBox: "0 0 157 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1643_57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M124.53 31.4498C122.898 29.3943 122.887 26.4838 124.427 24.3588L137.811 5.87407C138.242 5.27595 138.775 4.78103 139.367 4.38931C139.148 4.21661 138.925 4.04602 138.697 3.88175C129.306 -2.91654 116.08 -0.570413 109.638 9.22056C103.842 18.0301 105.795 29.9777 114.092 36.4896C115.817 37.8437 117.685 38.8736 119.629 39.5917C122.466 40.6406 125.657 39.6107 127.43 37.1614L128.776 35.3017C128.521 35.1375 128.27 34.9648 128.022 34.7858C126.68 33.8149 125.515 32.6903 124.532 31.4519L124.53 31.4498Z",
    fill: "url(#paint0_linear_1643_57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M149.399 6.45624C147.9 5.28107 146.278 4.386 144.589 3.76051C142.816 3.10553 140.887 3.38774 139.37 4.38811C140.636 5.38426 141.754 6.50257 142.717 7.71776C144.595 10.0828 144.608 13.4335 142.837 15.8808L128.777 35.2984C136.875 40.5572 147.841 38.3922 153.268 30.145C158.304 22.4916 156.606 12.111 149.399 6.45624Z",
    fill: "url(#paint1_linear_1643_57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M142.715 7.71832C141.75 6.50524 140.634 5.38693 139.368 4.38867C138.777 4.77829 138.244 5.27531 137.812 5.87343L124.428 24.3581C122.889 26.4831 122.899 29.3937 124.531 31.4492C125.513 32.6854 126.68 33.81 128.021 34.783C128.27 34.962 128.52 35.1347 128.775 35.299L142.835 15.8813C144.606 13.4341 144.596 10.0855 142.715 7.71832Z",
    fill: "url(#paint2_linear_1643_57)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M142.715 7.71832C141.75 6.50524 140.634 5.38693 139.368 4.38867C138.777 4.77829 138.244 5.27531 137.812 5.87343L124.428 24.3581C122.889 26.4831 122.899 29.3937 124.531 31.4492C125.513 32.6854 126.68 33.81 128.021 34.783C128.27 34.962 128.52 35.1347 128.775 35.299L142.835 15.8813C144.606 13.4341 144.596 10.0855 142.715 7.71832Z",
    fill: "url(#paint3_linear_1643_57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.717 7.7193C141.752 6.50622 140.636 5.38791 139.37 4.38965C138.779 4.77927 138.246 5.27629 137.814 5.87441L124.43 24.3591C122.891 26.4841 122.901 29.3946 124.533 31.4501C125.515 32.6864 126.682 33.811 128.023 34.784C128.272 34.963 128.522 35.1357 128.777 35.3L142.837 15.8823C144.608 13.4351 144.598 10.0865 142.717 7.7193Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M71.2842 15.8392C71.2842 12.8339 71.2821 9.82857 71.2884 6.82536C71.2884 6.26726 71.2736 5.70073 71.3642 5.15316C71.5916 3.77371 72.6931 2.81335 73.9483 2.83231C75.115 2.84916 76.0838 3.74633 76.246 5.15527C76.3723 6.26094 76.3218 7.38767 76.3281 8.50387C76.3408 10.5994 76.3239 12.697 76.3513 14.7925C76.3513 14.7988 76.3513 14.8072 76.3513 14.8136C76.3744 15.3822 77.0926 15.6918 77.5117 15.3043L77.518 15.298C78.7395 14.1375 79.8852 12.8929 81.1425 11.7724C82.2292 10.8016 83.1685 10.6373 84.0805 11.187C85.1377 11.8251 85.5357 13.173 85.1187 14.3123C84.866 15.0031 82.4377 17.444 82.1829 17.7241C81.8207 18.1222 81.608 18.6213 81.6206 19.1646C81.629 19.5458 81.7491 19.9228 81.9618 20.2408C82.1934 20.5883 82.4188 20.9442 82.6526 21.2938C83.158 22.0478 83.6571 22.806 84.1457 23.5705C84.4343 24.0212 84.7123 24.4782 84.9987 24.931C85.7316 26.0851 85.6389 27.5698 84.3774 28.3659C83.2844 29.0546 81.6922 28.6987 80.9783 27.7067C80.039 26.401 79.1839 25.0279 78.232 23.7284C78.2046 23.6905 78.1751 23.6568 78.1414 23.6231C77.6633 23.1387 76.8357 23.3177 76.5219 23.9222C76.4755 24.0127 76.4334 24.1054 76.4018 24.2002C76.2734 24.5814 76.3471 25.03 76.3281 25.4491C76.2291 27.6288 75.412 28.7977 73.963 28.8293C72.3035 28.8651 71.3157 27.5804 71.2926 25.2722C71.2673 22.827 71.2863 20.3798 71.2842 17.9347C71.2842 17.2355 71.2842 16.5363 71.2842 15.8392Z",
    fill: "#25245F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.4612 11.5054C61.6958 12.1435 61.6389 11.4822 63.29 11.1853C64.977 10.8841 66.9967 11.478 68.4203 12.7838C69.4207 13.6999 69.3323 15.2521 68.6099 16.086C67.837 16.9811 66.567 17.1559 65.6783 16.6989C65.4277 16.5704 65.1686 16.4546 64.9096 16.343C62.5803 15.3384 61.0492 16.2882 60.9755 18.845C60.9186 20.871 60.9692 22.8991 60.9523 24.9272C60.9481 25.5548 60.9586 26.1971 60.8217 26.8037C60.548 28.0104 59.8151 28.855 58.4819 28.8065C57.231 28.7602 56.3717 28.0631 56.0537 26.8332C55.9505 26.433 55.9231 26.0034 55.921 25.5864C55.9126 21.7408 55.8894 17.8972 55.9273 14.0516C55.9442 12.2846 56.9235 10.7809 59.4549 11.5033L59.4612 11.5054Z",
    fill: "#25245F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52.9236 13.8105C52.7804 11.6413 51.1082 10.3376 49.3918 11.0979C48.084 11.6771 47.0078 11.4812 45.7463 11.1316C39.8599 9.4952 34.6011 14.4802 34.4368 19.4589C34.2262 25.9202 40.4601 30.1112 45.7568 28.5717C46.6582 28.3084 47.7323 28.1652 48.6189 28.3885C51.3273 29.075 52.8584 28.1084 52.9658 25.3389C53.0332 23.5951 53.0626 15.8997 52.9236 13.8126V13.8105ZM43.615 23.9511C41.3236 23.9511 39.4661 22.0935 39.4661 19.8022C39.4661 17.5108 41.3236 15.6533 43.615 15.6533C45.9063 15.6533 47.7639 17.5108 47.7639 19.8022C47.7639 22.0935 45.9063 23.9511 43.615 23.9511Z",
    fill: "#25245F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M104.722 13.8105C104.579 11.6413 102.907 10.3376 101.191 11.0979C99.8828 11.6771 98.8066 11.4812 97.5451 11.1316C91.6587 9.4952 86.3999 14.4802 86.2357 19.4589C86.0251 25.9202 92.2589 30.1112 97.5556 28.5717C98.457 28.3084 99.5311 28.1652 100.418 28.3885C103.126 29.075 104.657 28.1084 104.765 25.3389C104.832 23.5951 104.861 15.8997 104.722 13.8126V13.8105ZM95.4138 23.9511C93.1224 23.9511 91.2649 22.0935 91.2649 19.8022C91.2649 17.5108 93.1224 15.6533 95.4138 15.6533C97.7052 15.6533 99.5627 17.5108 99.5627 19.8022C99.5627 22.0935 97.7052 23.9511 95.4138 23.9511Z",
    fill: "#25245F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.5798 15.5413C31.1143 14.0523 30.2172 12.7171 28.9936 11.7441C27.4435 10.512 25.4702 9.93077 23.5031 9.94762C22.4585 9.95605 21.416 10.1414 20.4325 10.4931C19.4511 10.8448 18.6255 11.4661 17.7073 11.942C17.562 12.0179 17.4082 12.0874 17.2503 12.1484C16.6395 12.3822 15.9593 12.2474 15.4475 11.841L15.4412 11.8367C13.8912 10.6047 11.9178 10.0234 9.95076 10.0403C8.90616 10.0487 7.86367 10.234 6.88015 10.5858C6.57478 10.6953 6.28414 10.8301 6.00194 10.9796C5.4312 11.2807 4.74884 11.2007 4.25392 10.7858C3.83903 10.4383 3.30621 10.2298 2.72283 10.2298H2.40271C1.08012 10.2298 0.0102539 11.3018 0.0102539 12.6223V26.3452C0.0102539 27.6678 1.08223 28.7377 2.40271 28.7377H2.72283C4.04542 28.7377 5.11529 27.6657 5.11529 26.3452V18.3023C5.30273 16.906 6.0588 15.8298 7.42351 15.1917C8.85351 14.5219 10.5531 14.7578 11.7809 15.7392C12.9919 16.7059 13.3815 18.0474 13.3815 19.5364V26.1747C13.3815 27.2403 14.0281 28.228 15.0368 28.5734C16.092 28.9357 17.1008 28.6261 17.7536 27.9648C18.2633 27.4972 18.5876 26.8275 18.5876 26.082C18.5876 23.6706 18.5961 21.2571 18.6276 18.8456C18.6508 17.1376 19.4174 15.8319 20.9801 15.099C22.4101 14.4293 24.1097 14.6651 25.3375 15.6466C26.5485 16.6132 26.9381 17.9548 26.9381 19.4438V26.082C26.9381 27.1708 27.6162 28.1712 28.6545 28.5018C30.4194 29.0641 32.0431 27.7626 32.0431 26.082V21.6446C32.0431 19.627 32.1968 17.4915 31.584 15.5413H31.5798Z",
    fill: "#25245F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M141.803 25.6355C141.664 24.3213 140.453 23.3314 138.989 23.3314H136.993C136.329 23.3314 135.916 22.9755 135.752 22.6407C135.659 22.4532 135.548 22.0762 135.857 21.6677L141.148 14.7072C141.828 13.8122 141.82 12.6201 141.131 11.7293C140.623 10.9795 139.76 10.5352 138.812 10.5352H129.32C127.857 10.5352 126.648 11.525 126.507 12.8392C126.433 13.5342 126.654 14.2123 127.134 14.743C127.659 15.3264 128.427 15.6591 129.244 15.6591H131.65C132.22 15.6591 132.572 15.9624 132.713 16.2467C132.808 16.4363 132.869 16.7311 132.625 17.0512L127.115 24.3002C126.273 25.408 126.433 26.897 127.486 27.7689C127.857 28.0742 128.309 28.2806 128.802 28.3649C129.049 28.426 129.278 28.4554 129.501 28.4554H139.069C139.886 28.4554 140.655 28.1206 141.179 27.5393C141.657 27.0065 141.881 26.3304 141.807 25.6355H141.803Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M124.506 13.8105C124.363 11.6413 122.691 10.3376 120.974 11.0979C119.666 11.6771 118.59 11.4812 117.329 11.1316C111.442 9.4952 106.184 14.4802 106.019 19.4589C105.809 25.9202 112.043 30.1112 117.339 28.5717C118.241 28.3084 119.315 28.1652 120.201 28.3885C122.91 29.075 124.441 28.1084 124.548 25.3389C124.616 23.5951 124.645 15.8997 124.506 13.8126V13.8105ZM115.197 23.9511C112.906 23.9511 111.049 22.0935 111.049 19.8022C111.049 17.5108 112.906 15.6533 115.197 15.6533C117.489 15.6533 119.346 17.5108 119.346 19.8022C119.346 22.0935 117.489 23.9511 115.197 23.9511Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1643_57",
    x1: 114.101,
    y1: 9.269,
    x2: 138.072,
    y2: 30.5168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1643_57",
    x1: 154.679,
    y1: 33.9822,
    x2: 131.877,
    y2: 14.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00CDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00C1C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#009DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1643_57",
    x1: 117.584,
    y1: 5.3385,
    x2: 141.552,
    y2: 26.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1643_57",
    x1: 153.064,
    y1: 35.8992,
    x2: 130.26,
    y2: 16.7237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00D3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00CAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00BDCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00A9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.154,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkaazLogoBlue);
export default __webpack_public_path__ + "static/media/markaazLogoBlue.caa7b1a295ce2a2e270d4d039d9795fb.svg";
export { ForwardRef as ReactComponent };